import React, { FC } from 'react'

import { ProductFeatureCard } from 'components/product-feature-card/ProductFeatureCard'

import classes from './ShowcaseFeatureDisplay.module.scss'

interface FeatureCardData {
  icon?: string
  text?: string
}

interface CardsGridProps {
  cards: FeatureCardData[]
}

export const CardsGrid: FC<CardsGridProps> = ({ cards }) => {
  return (
    <div className={classes.cardsGrid}>
      {cards.map(({ icon, text }, i) => (
        <ProductFeatureCard key={i} icon={icon} text={text} row={true} />
      ))}
    </div>
  )
}
